















































































































































































































































import { colorsOrdered } from '@/constants'

import { accountService } from '@/services'
import { generateAPIUrl, isFeatureAccessible } from '@/utils'
import Vue from 'vue'
import { RouteConfig } from 'vue-router'

type RouterNav = {
    children: RouterNav[]
    text: string,
    path:string,
    dialog: boolean,
    navDropDown: boolean
}

export default Vue.extend({
    name: 'navbar',
    data() {
        return {
            drawer: false,
            routes: [] as RouterNav[],
            logo: ''
        }},
    methods: {
        closeNav(){
            this.routes.forEach( routerNav => {
                routerNav.navDropDown = false
            })
        },
        closeMenu(routerNav: RouterNav) {
            routerNav.dialog = false
        },
        generateRoutes() {
            const finalRoutes: RouterNav[] = []
            const routeMap: Record<string, RouterNav> = {}
            const filteredRoutes: RouteConfig[] = this.$store.state.routes[0].children.filter((x: RouteConfig)=>typeof x.meta?.navBar === 'number' && this.userCanAccessPage(x.meta?.requiredPermissions || []))

            filteredRoutes.forEach( filteredRoute => {
                const grouping = filteredRoute.meta?.group
                if(grouping) {
                    // Assemble the groupings if it doesn't exist
                    let overallGrouping = grouping.split('.')
                    overallGrouping.reduce( (acc: string, curr: string) => {
                        let groupObj = null
                        let routeMapKey = [acc, curr].filter(Boolean).join('.')

                        if(!acc && !routeMap[routeMapKey]) {
                            groupObj = {
                                children: [],
                                text: curr,
                                path: '',
                                dialog: false,
                                navDropDown: false
                            }
                            finalRoutes.push(groupObj)
                        } else if(!routeMap[routeMapKey]) {
                            groupObj = {
                                children: [],
                                text: curr,
                                path: '',
                                dialog: false,
                                navDropDown: false
                            }

                            const lastDot = routeMapKey.lastIndexOf('.')
                            const parentKey = lastDot !== -1 ? routeMapKey.substring(0, lastDot) : routeMapKey
                            const parentGroup = routeMap[parentKey]
                            parentGroup.children.push(groupObj)
                        }

                        if (groupObj) {
                            routeMap[routeMapKey] = groupObj
                        }

                        return acc + curr
                    }, '')

                    let groupObj = routeMap[grouping]
                    groupObj.children.push({
                        children: [],
                        text: filteredRoute.meta?.text ?? '',
                        path: filteredRoute.path.replace(new RegExp('/:.+', 'g'), ''),
                        dialog: false,
                        navDropDown: false
                    })
                } else {
                    finalRoutes.push({
                        children: [],
                        text: filteredRoute.meta?.text ?? '',
                        path: filteredRoute.path.replace(new RegExp('/:.+', 'g'), ''),
                        dialog: false,
                        navDropDown: false
                    })
                }
            })
            this.routes = finalRoutes

            
        },
        onLogout() {
            this.$store.dispatch('logout', true)
        },
        getColor(user:any) {
            const c = window.localStorage.getItem('colors')
            const findColor = c ? JSON.parse(c) : colorsOrdered

            if (!user || !user?.username)
                return findColor[0]

            const code = (user.username.charCodeAt(0) +
                user.firstName.charCodeAt(2) +
                user.lastName.charCodeAt(2)) - 120

            if (isNaN(code) || code < 0)
                return findColor[0]

            return findColor[Math.min(code,findColor.length-1)]
        },
        userCanAccessPage(permissions: string[]) {
            return isFeatureAccessible(permissions, this.$store.getters.user.permissions)
        },
        async onSwitchClient(clientId: string) {
            try {
                await this.$store.dispatch('showPageLoading', true)
                await accountService.SwitchClient(clientId)
            } catch(e) {
                console.log(e)
            }
            await this.$store.dispatch('showPageLoading', false)
            window.location.href = '/'
            
        }
    },
    async mounted() {
        // ===== Retrieve Logo and favicon (colors, styles, logo, and favicon) =====
        const apiUrl = new URL(generateAPIUrl())
        apiUrl.pathname = '/ThemeSettings/GetLogo'
        apiUrl.search = `?now=${Date.now()}`

        this.logo = apiUrl.toString()

        let favicon = document.querySelector('link[rel*=\'icon\']') as any
        if(favicon) {
            apiUrl.pathname = '/ThemeSettings/GetFavicon'
            favicon.href = apiUrl.toString()
        }
        // End of manipulating Themes
        this.generateRoutes()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    }
})
